module.exports = __webpack_public_path__ + "cat_img3@2x.png?eff2e0249d8d7c8df8bff36b6b5d862d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cat_img3@2x.png
// module id = 176
// module chunks = 0